// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".collapsed-height[data-v-9015812a] {\n  max-height: 180px;\n  overflow: auto;\n}\n.expanded-height[data-v-9015812a] {\n  max-height: 450px;\n  overflow: auto;\n}\nfieldset[data-v-9015812a] {\n  border-bottom: none;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
